import { isDefined } from '../../ts-utils';
import { ReactionCodeValue } from '../reaction-types';
import { defaultReactionsInMenu, mainReactionCode, resolveMainReactionName, } from '../default-reactions';
import { getReactionCode, getReactionCodeByName } from './reaction-converters';
export const getValidReactions = (reactions, config) => {
    if (config.type === 'likes') {
        return reactions
            .filter((r) => r.reactionCode === ReactionCodeValue.LIKE)
            .map((r) => ({
            ...r,
            reactionCode: getReactionCodeByName(resolveMainReactionName(config.mainEmotion)),
        }));
    }
    const validReactionNames = (config.emotions ?? defaultReactionsInMenu).filter(isDefined);
    const validReactionCodes = [
        ...validReactionNames.map((n) => getReactionCode(n, resolveMainReactionName(config.mainEmotion))),
        mainReactionCode,
    ];
    return reactions.filter((r) => validReactionCodes.includes(r.reactionCode));
};
//# sourceMappingURL=get-valid-reactions.js.map